var map = {
	"./build.svg": "2580",
	"./dealer.svg": "a1fe",
	"./finance.svg": "b671",
	"./inclusion.svg": "cdea",
	"./learn.svg": "b820",
	"./match.svg": "25af",
	"./right.svg": "ecef",
	"./showMemory.svg": "573b",
	"./wheel.svg": "c7ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e57c";